export default __webpack_public_path__ + "static/media/logo_gjm.a7a6d4be.png";